import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategoriesSection from './components/CategoriesSection';
import LatestSection from './components/LatestSection';
import ClassicSection from './components/ClassicSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const homepageSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        '@id': 'https://www.heilia630.com/#website',
        'url': 'https://www.heilia630.com/',
        'name': '黑料六点半',
        'description': '24小时实时追踪娱乐圈潜规则、网红塌房与明星擦边黑料。联合51黑料吃瓜网，整合历年大瓜合集与最新热点，免费无删减看料。',
        'publisher': {
          '@type': 'Organization',
          '@id': 'https://www.heilia630.com/#organization',
          'name': '黑料六点半',
          'url': 'https://www.heilia630.com/',
        },
        'inLanguage': 'zh-CN',
      },
      {
        '@type': 'WebPage',
        '@id': 'https://www.heilia630.com/#webpage',
        'url': 'https://www.heilia630.com/',
        'name': '黑料六点半 | 51黑料吃瓜 - 今日大瓜 | 娱乐圈潜规则 | 网红塌房事件实时追踪',
        'description': '黑料六点半联合51黑料吃瓜网，24小时实时追踪娱乐圈潜规则、网红塌房与明星擦边黑料。整合历年大瓜合集与最新热点，免费无删减看料，吃瓜无罪八卦有理，立即访问掌握内幕。',
        'isPartOf': { '@id': 'https://www.heilia630.com/#website' },
        'about': { '@id': 'https://www.heilia630.com/#organization' },
        'primaryImageOfPage': {
          '@type': 'ImageObject',
          'url': 'https://www.heilia630.com/og-default.jpg',
        },
        'inLanguage': 'zh-CN',
      },
      {
        '@type': 'FAQPage',
        'mainEntity': [
          {
            '@type': 'Question',
            'name': '黑料六点半的内容来源可靠吗？',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': '我们坚持多方交叉验证原则，每条爆料均来源于公开报道、当事人社交账号或可靠线人提供的信息。我们会对信息进行初步核实后再发布，但对于未经法律程序确认的内容，请读者理性看待。',
            },
          },
          {
            '@type': 'Question',
            'name': '如何在黑料六点半投稿爆料？',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': '您可以通过"关于我们"页面的联系方式投稿。我们承诺对所有爆料人信息严格保密，采用加密通道传输，确保您的隐私安全。',
            },
          },
          {
            '@type': 'Question',
            'name': '黑料六点半更新频率是怎样的？',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': '我们团队24小时轮班监控娱乐圈动态，确保重大爆料第一时间推送。常规内容每日至少更新3-5篇，突发大瓜不受时间限制随时更新。',
            },
          },
          {
            '@type': 'Question',
            'name': '被爆料方要求删帖怎么办？',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': '我们尊重事实与法律。如果爆料内容存在事实性错误，我们会在核实后及时更正并致歉。但对于真实且符合公众知情权的报道，我们坚持不因外部压力而删帖的原则。',
            },
          },
          {
            '@type': 'Question',
            'name': '黑料六点半和51黑料吃瓜网是什么关系？',
            'acceptedAnswer': {
              '@type': 'Answer',
              'text': '黑料六点半与51黑料吃瓜网是战略合作伙伴关系。双方共享部分爆料线索资源，但各自保持独立的编辑方针和内容审核标准，共同为吃瓜群众提供更全面的娱乐八卦资讯。',
            },
          },
        ],
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="黑料六点半 | 51黑料吃瓜 - 今日大瓜 | 娱乐圈潜规则 | 网红塌房事件实时追踪"
        description="黑料六点半联合51黑料吃瓜网，24小时实时追踪娱乐圈潜规则、网红塌房与明星擦边黑料。整合历年大瓜合集与最新热点，免费无删减看料，吃瓜无罪八卦有理，立即访问掌握内幕。"
        keywords="黑料六点半,51黑料,今日大瓜,娱乐圈潜规则,网红塌房,明星擦边,黑料合集,免费吃瓜"
        canonicalUrl="/"
        ogType="website"
        schema={homepageSchema}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <FeaturedSection />
          <CategoriesSection />
          <LatestSection />
          <ClassicSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}